/**
 * Calculates what page on the vehicle SRP we are on based on starting point in total inventory and num vehicles on the page
 * @param {number} pageStart Starting place of first vehicle in total count of inventory
 * @param {number} pageSize Number of vehicles showing per page
 * @returns
 */
export const getPageNumber = (pageStart, pageSize) => {
	return Math.floor(pageStart / pageSize) + 1;
};

// Personalization / non-content params dropped from the crawlable SEO pagination
// hrefs (per ADR-0014 D1, Scott's call). A crawlable URL's query params should
// mirror only what determines its rendered content. On the AI-bot path the
// content is geo-neutral (the WIS fetch sends no prefs / skips geo), so geo
// params don't belong in the body anchors — keep content-defining facets
// (make/model/year/trim/price/sort/etc.) + the start offset, drop these.
// (ws-inv-data's head-level rel=prev/next may still carry geo — that's the
// complementary/deprecated hint; the body anchors are the load-bearing signal.)
const PERSONALIZATION_PARAMS = ['geoZip', 'geoRadius'];

/**
 * Returns a copy of `parameterMap` with personalization params (geo) removed, so
 * the crawlable pagination hrefs carry only content-defining params. Extend
 * PERSONALIZATION_PARAMS if other non-content/personalization params surface.
 *
 * @param {object} parameterMap inbound query params
 * @returns {object} parameterMap without personalization params
 */
export const stripPersonalizationParams = (parameterMap = {}) => {
	const cleaned = { ...parameterMap };
	PERSONALIZATION_PARAMS.forEach((key) => delete cleaned[key]);
	return cleaned;
};
